import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Box } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import logo from "../../assets/images/linde-logo.png";
import logo_path from "../../assets/customer_specific_data/logo_header.png";
import DrawerMenu from "./drawerMenu";
import Notification from "./notification";
import { RootState } from "../../reducers/rootReducer";
import { AzureAD, AuthenticationState, IAzureADFunctionProps } from "react-aad-msal";
import { authProvider } from "../authProvider";
import TerminationNotification from "./terminationnotification";
import { useAuth } from "react-oidc-context";
import { isPingIDAuth, refreshAccessToken } from "../../utilities/helperFunctions";
import { AZURE_REFRESH_TOKEN_INTERVAL } from "../../utilities/GlobalConstants";

const Header: React.SFC = () => {
  const { pageTitle } = useSelector((state: RootState) => state.appState);
  const dispatch = useDispatch();

  const oidcAuth = useAuth(); 
  const [auth, setAuth] = useState(oidcAuth);

  React.useEffect(() => {
    setAuth(oidcAuth);
  }, [oidcAuth]);

  useEffect(() => { 

    if(!isPingIDAuth()){
      const intervalId = setInterval(() => {
        console.log(refreshAccessToken(),'check refresh token generated in header component');
        
        refreshAccessToken();
      }, AZURE_REFRESH_TOKEN_INTERVAL);
  
      return () => clearInterval(intervalId);
    }

  }, []);

  const AzureADAuth = (componentName) => {
    return(
      <AzureAD provider={authProvider} forceLogin={false}>
      {({ login, logout, authenticationState, error, accountInfo }) => {
        console.log('AzureADAuth is called and authenticationState :', authenticationState,'componentName',componentName);
        
        if (authenticationState === "Authenticated") {
          if(componentName === "DrawerMenu")
            return <DrawerMenu />;
          else if(componentName === "Notification")
            return <Notification />;
        } else {
          return <div></div>;
        }
      }}
    </AzureAD>
    )
  }
  
  const PingIDAuth = (componentName) => {
   
    console.log("In a Header Component: ")
    console.log(auth)
    console.log('PingIDAuth is called and auth.isAuthenticated :', auth.isAuthenticated,'componentName',componentName);


    if (auth.isAuthenticated){
      if(componentName === "DrawerMenu")
        return <DrawerMenu />;
      else if(componentName === "Notification")
        return <Notification />;
    }
    else{
      return <div></div>;
    }
  }

  return (
    <header>
      <Grid container justifyContent="space-between" alignItems="center" className="header-content">
        <Grid item>
          <Box display="flex" alignItems="center">
            <Box>
               {/* Ping ID change: Will add condition for authentication type */}
              {isPingIDAuth() ? PingIDAuth("DrawerMenu") : AzureADAuth("DrawerMenu")}
            </Box>
            <Box>
              <NavLink className="header-link" to="/">
                <h1>Linde Virtual Furnace</h1>
              </NavLink>
            </Box>
            <Box ml={4}>
              <h2 className="header-link">{pageTitle}</h2>
            </Box>
          </Box>
        </Grid>

        <Grid item>
          <Box display="flex" alignItems="center">
            <Box mr={1}>
              <TerminationNotification />
            </Box>
            <Box mr={1}>
              {isPingIDAuth() ? PingIDAuth("Notification") : AzureADAuth("Notification")}
            </Box>
            <Box>
              <NavLink className="logo-link" to="/">
                {logo_path && <img src={logo_path} className="logo-customer" alt="Linde, Making our world more productive" />}
                <img src={logo} className="logo" alt="Linde, Making our world more productive" />
              </NavLink>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </header>
  );
};

export default Header;
